export const TEMPLATE_KIND_QUERY_PARAM = 'type';
